
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

var $5957c8c2dc108832$exports = {};

(parcelRequire("1hiTA")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"XdB14\",\"ShareAndRestrictDialog.8cca5f2a.js\",\"g35Ma\",\"cs.2e00ce5f.js\",\"6jn9l\",\"da.56fbd366.js\",\"1w7fH\",\"de.e91d9195.js\",\"6oBxf\",\"en-GB.8039e05e.js\",\"1TTQt\",\"en-US.c938c2db.js\",\"k2w8V\",\"en-XA.efd8ad0c.js\",\"9DH1A\",\"en-XB.062aa10d.js\",\"88qtk\",\"en-ZZ.a7233a82.js\",\"loV6E\",\"es.814590b7.js\",\"3Afk1\",\"et.cf27390c.js\",\"3xvJH\",\"fi.c4a66001.js\",\"eYO04\",\"fr.b0e3dd5a.js\",\"6GuZx\",\"hr.35ebecc9.js\",\"4Afn2\",\"hu.e4c47442.js\",\"5t7J7\",\"it.382e1bc4.js\",\"fPagA\",\"ja.9266ed04.js\",\"dsh71\",\"ko.9409f7e5.js\",\"03jrX\",\"nb.22ba0abd.js\",\"gebmR\",\"nl.475be4cc.js\",\"4YGt1\",\"pl.ab4a7820.js\",\"9amHO\",\"pt-BR.35f5ac70.js\",\"42zva\",\"ro.079a2cc0.js\",\"cxvqH\",\"ru.4608919c.js\",\"aEBds\",\"sl.23b7af36.js\",\"4QuXE\",\"sr-RS.e1da887a.js\",\"fZbef\",\"sr-YR.1a61d169.js\",\"hfdfW\",\"sr.ef83e66a.js\",\"cnTvB\",\"sv.6b2501d9.js\",\"4zZgK\",\"th.59590c03.js\",\"lCDYE\",\"tr.4a2fdba4.js\",\"3umn0\",\"uk.a17745d3.js\",\"eMrsH\",\"vi.86307ba9.js\",\"ffbcZ\",\"zh-CN.75ef950d.js\",\"ifRct\",\"zh-TW.d55f09eb.js\"]"));


$parcel$global.rlb("3b8uf")
//# sourceMappingURL=ShareAndRestrictDialog.runtime.6016ff89.js.map
